import { render, staticRenderFns } from "./PushPlatform.vue?vue&type=template&id=79f80480"
import script from "./PushPlatform.vue?vue&type=script&lang=js"
export * from "./PushPlatform.vue?vue&type=script&lang=js"
import style0 from "./PushPlatform.vue?vue&type=style&index=0&id=79f80480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports